import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PILLARS } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Pillars = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="relative bg-[#0B2B26] text-[#F6F4EE] py-24 sm:py-36 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow light>Preventive · Chronic · Wellness</Eyebrow>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              One framework for <span className="italic text-[#E9A184]">every</span> kind of care.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="mt-10">
            <div className="relative rounded-[28px] overflow-hidden aspect-[4/3]">
              <motion.img style={{ y }} src="/images/clinic.jpg" alt="Welcon clinic interior" className="absolute inset-0 h-[118%] -top-[9%] w-full object-cover" />
            </div>
            <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[#B9CFC9]">Representative image · clinic photo to come</p>
          </Reveal>
        </div>
        <div data-testid="care-framework-pillars-grid" className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-white/10 rounded-[28px] overflow-hidden self-start">
          {PILLARS.map((p, i) => (
            <Reveal key={p.name} delay={(i % 2) * 0.08} className="bg-[#0B2B26]">
              <div data-testid={`pillar-${i + 1}`} className="group h-full p-8 sm:p-10 transition-colors duration-500 hover:bg-[#0E4D44]">
                <span className="font-mono text-xs text-[#E9A184]">0{i + 1}</span>
                <h3 className="mt-8 font-display text-2xl sm:text-3xl tracking-tight">{p.name}</h3>
                <p className="mt-3 text-sm sm:text-base text-[#C7D8D2] leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
